
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M17.381 4.618a2.123 2.123 0 010 3.002L7.39 17.61a2 2 0 01-.93.527l-3.464.866.866-3.464c.088-.352.27-.673.527-.93l9.992-9.99a2.122 2.122 0 013 0z"}}),_c('path',{attrs:{"d":"M15.501 9.5L12.5 6.497M21.003 18.002l-1.094 1.095a3.095 3.095 0 01-4.377 0v0a3.101 3.101 0 00-4.378 0"}})])
          )
        }
      }
    